import React from 'react';
import { Bunkering } from 'src/types/ViewModel/Bunkering/Bunkering';
import { BunkeringStatus } from 'src/types/ViewModel/Bunkering/BunkeringStatus';
import { getBunkeringStatusEnumDisplayName } from '../../BunkeringUtils';
import { formatDateTime } from 'odfjell-date-time-utils/dateTimeFormatter';
import {
    BunkeringStatusHeader,
    BunkeringStatusListWrapper,
    BunkeringStatusTableRowStyle,
    BunkeringStatusTableStyle,
    FuelReceivedTableBodyStyle,
    FuelReceivedTableHeadStyle,
    TableColumnHeaderStyle,
} from '../../Bunkering.styles';
import { getLuxonDateTime, isDateBefore, isDateSame } from 'odfjell-date-time-utils/dateTimeUtils';
import { ListButton } from 'src/styles/button.style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAuthStore } from 'src/context/AuthContext';
import OdfjellDatePicker from 'src/components/common/date-picker/OdfjellDatePicker';
import Tooltip from 'src/components/ui/tooltip/Tooltip';

interface BunkerRegStatusListProps {
    bunkering: Bunkering;
    handleDateChange: (status: BunkeringStatus, date: Date) => void;
    deleteBunkeringStatus: (status: BunkeringStatus) => void;
}

const BunkerRegStatusList: React.FC<BunkerRegStatusListProps> = ({ bunkering, handleDateChange, deleteBunkeringStatus }) => {
    const { role } = useAuthStore();

    return (
        <BunkeringStatusListWrapper>
            <BunkeringStatusHeader>
                <h2>Status history</h2>
            </BunkeringStatusHeader>
            <BunkeringStatusTableStyle>
                <FuelReceivedTableHeadStyle>
                    <BunkeringStatusTableRowStyle>
                        <TableColumnHeaderStyle>Status</TableColumnHeaderStyle>
                        <TableColumnHeaderStyle>Active from</TableColumnHeaderStyle>
                        <TableColumnHeaderStyle>Updated at</TableColumnHeaderStyle>
                        <TableColumnHeaderStyle></TableColumnHeaderStyle>
                    </BunkeringStatusTableRowStyle>
                </FuelReceivedTableHeadStyle>
                <FuelReceivedTableBodyStyle>
                    {bunkering?.bunkeringStatuses
                        .sort((a: BunkeringStatus, b: BunkeringStatus) =>
                            isDateSame(a.activeFromDate, b.activeFromDate) ? 0 : isDateBefore(a.activeFromDate, b.activeFromDate) ? 1 : -1
                        )
                        .map((status: BunkeringStatus, index) => (
                            <BunkeringStatusTableRowStyle key={index}>
                                <td>{getBunkeringStatusEnumDisplayName(status.status, status.activeFromDate, bunkering.approvedForUseAt)}</td>
                                <td>
                                    <OdfjellDatePicker
                                        disabled={!role.isWriter}
                                        format={'dd.MM.yyyy'}
                                        placeholder={''}
                                        value={getLuxonDateTime(status?.activeFromDate)}
                                        onChange={(date) => handleDateChange(status, date.toJSDate())}
                                        allowClear={false}
                                    />
                                </td>
                                <td>
                                    <Tooltip text={`Updated by: ${status.updatedBy}`} type="information">
                                        {formatDateTime(status.updatedAt, 'dd.MM.yyyy HH.mm')}
                                    </Tooltip>
                                </td>
                                <td>
                                    {bunkering.bunkeringStatuses.length > 1 && index === 0 && (
                                        <ListButton onClick={() => deleteBunkeringStatus(status)} disabled={!role.isWriter}>
                                            <FontAwesomeIcon title="Delete latest status" icon="trash" />
                                        </ListButton>
                                    )}
                                </td>
                            </BunkeringStatusTableRowStyle>
                        ))}
                </FuelReceivedTableBodyStyle>
            </BunkeringStatusTableStyle>
        </BunkeringStatusListWrapper>
    );
};

export default BunkerRegStatusList;
